<template>
  <div id="select-ai-tone-modal" class="container p-0">
    <HMModalHeader
      :title="$t('PRODUCTS.TITLE.SELECT_TONE')"
      @close="$emit('close')"
    />
    <div
      class="price-option-container"
      v-for="option in toneOptions"
      :key="option.value"
    >
      <HMRadio
        class="tone-option mb-1"
        v-model="selectedTone"
        group="price-options"
        :name="option.value"
      >
        <span>{{ option.label }}</span>
      </HMRadio>
      <div class="smaller mb-4">{{ option.description }}</div>
    </div>
    <HMModalFooter class="mt-3" @close="$emit('close')">
      <template slot="submit">
        <HMButton color="primary" @click="$emit('close', selectedTone)">
          {{ $t('PRODUCTS.LINK.GENERATE_PAGE') }}
        </HMButton>
      </template>
    </HMModalFooter>
  </div>
</template>

<script>
export default {
  name: 'SelectAIToneModal',
  data() {
    return {
      selectedTone: 'inspirational',
    };
  },
  computed: {
    toneOptions() {
      /*
      Conversational: This tone is friendly, approachable, and mimics the style of everyday conversation. It can be effective for products that have a personal or informal connection with their customers.
      Inspirational: This tone is uplifting, motivational, and seeks to inspire and encourage customers to take action. It can be effective for products that are focused on personal growth, wellness, or self-improvement.
      Authoritative: This tone is confident, knowledgeable, and establishes the brand or product as an expert in its field. It can be effective for products that require a high level of expertise or credibility.
      Urgent: This tone creates a sense of urgency or scarcity, encouraging customers to act quickly. It can be effective for products that are time-sensitive or have limited availability.
      Humorous: This tone uses humor or wit to engage customers and create a memorable impression. It can be effective for products that have a lighthearted or playful brand personality.
      Emotional: This tone taps into the customer's emotions, creating a connection and motivating them to take action. It can be effective for products that have a strong emotional appeal, such as products related to family, pets, or personal values.
      */
      return [
        {
          value: 'inspirational',
          label: this.$t('GENERAL.TONES.INSPIRATIONAL'),
          description: this.$t('GENERAL.TONES.INSPIRATIONAL_DESCRIPTION'),
        },
        {
          value: 'conversational',
          label: this.$t('GENERAL.TONES.CONVERSATIONAL'),
          description: this.$t('GENERAL.TONES.CONVERSATIONAL_DESCRIPTION'),
        },
        {
          value: 'urgent',
          label: this.$t('GENERAL.TONES.URGENT'),
          description: this.$t('GENERAL.TONES.URGENT_DESCRIPTION'),
        },
        {
          value: 'humorous',
          label: this.$t('GENERAL.TONES.HUMOROUS'),
          description: this.$t('GENERAL.TONES.HUMOROUS_DESCRIPTION'),
        },
        {
          value: 'emotional',
          label: this.$t('GENERAL.TONES.EMOTIONAL'),
          description: this.$t('GENERAL.TONES.EMOTIONAL_DESCRIPTION'),
        },
        {
          value: 'authoritative',
          label: this.$t('GENERAL.TONES.AUTHORITATIVE'),
          description: this.$t('GENERAL.TONES.AUTHORITATIVE_DESCRIPTION'),
        },
      ];
    },
  },
  methods: {},
  mounted() {
    //this.$trackOnPage('teacher open select products');
  },
};
</script>

<style lang="scss" scoped>
@import '@/web/styles/components-variables.scss';
</style>
